import script from "./JaMonitorManagementDeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./JaMonitorManagementDeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./JaMonitorManagementDeleteModal.vue?vue&type=style&index=0&id=2ff8a427&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff8a427"]])

export default __exports__